import Link from 'next/link';
import { useTranslation } from 'next-i18next';
import { trackEvent } from '@zep/logger/tracking';
import { Button } from '@/ui_v3';
import { BOARD_CREATE_PATH } from '../consts';

/**
 * 상·하단이 같은 버튼을 쓰지만 문구는 다르다 — 시안상 Hero 는 "무료로 무제한 보드
 * 만들기", 하단 CTA 는 "무료로 보드 만들기"다. 그래서 라벨도 location 으로 가른다.
 */
const LABEL_KEY = {
  hero: 'boardLanding:cta.hero',
  bottom: 'boardLanding:cta.bottom'
} as const;
type Props = {
  /** 같은 버튼이 상·하단에 있으므로 어느 쪽이 눌렸는지 구분해 싣는다. */
  location: 'hero' | 'bottom';
};
export function BoardLandingCtaButton({
  location
}: Props) {
  const {
    t
  } = useTranslation(['boardLanding']);
  return <Button variant="contained" intent="strong" size="lg" rounded="default" asChild data-sentry-element="Button" data-sentry-component="BoardLandingCtaButton" data-sentry-source-file="BoardLandingCtaButton.tsx">
      <Link href={BOARD_CREATE_PATH} data-testid="board-landing-cta" onClick={() => trackEvent('board_landing_cta_click', {
      location
    })} data-sentry-element="Link" data-sentry-source-file="BoardLandingCtaButton.tsx">
        {t(LABEL_KEY[location])}
      </Link>
    </Button>;
}